import { Box, Button, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export const MatchContainer = ({ children, onAdd, onRemove, match }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const buttonSx = {
    padding: '0px',
    borderRadius: '8px',
    width: '50px',
    minWidth: '50px',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  return (
    <Box className="w-full flex gap-2">
      <Button
        onClick={() => onRemove(match)}
        sx={{
          ...buttonSx,
          bgcolor: colors.error + '30',
          border: `1px solid ${colors.error}80`,
          ':hover': {
            bgcolor: colors.error,
            border: `1px solid ${colors.error}`,
          },
        }}
      >
        <CloseIcon />
      </Button>
      <Box
        className="rounded-lg w-full flex items-center px-2 py-1"
        sx={{ bgcolor: colors.card }}
      >
        {children}
      </Box>
      <Button
        onClick={() => onAdd(match)}
        sx={{
          ...buttonSx,
          bgcolor: colors.success + '30',
          border: `1px solid ${colors.success}80`,
          ':hover': {
            bgcolor: colors.success,
            border: `1px solid ${colors.success}`,
          },
        }}
      >
        <CheckIcon />
      </Button>
    </Box>
  );
};
